import { deleteCommission } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useDeleteCommission = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteCommission, {
        onSuccess: () => {
            toast.success("Deleted sucesfully");
            queryClient.invalidateQueries('commissions');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}